{
  "AGENT_BOTS": {
    "HEADER": "Bots",
    "LOADING_EDITOR": "Loading editor...",
    "DESCRIPTION": "Agent Bots are like the most fabulous members of your team. They can handle the small stuff, so you can focus on the stuff that matters. Give them a try.You can manage your bots from this page or create new ones using the 'Configure new bot' button.",
    "LEARN_MORE": "Learn about agent bots",
    "GLOBAL_BOT": "Системен бот",
    "GLOBAL_BOT_BADGE": "Системен",
    "AVATAR": {
      "SUCCESS_DELETE": "Аватарът на бота е изтрит успешно",
      "ERROR_DELETE": "Грешка при изтриване на аватара на бота, моля опитайте отново"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Select an agent bot",
      "DESC": "Assign an Agent Bot to your inbox. They can handle initial conversations and transfer them to a live agent when necessary.",
      "OPTION": "{name} ({description})",
      "SUBMIT": "Обновяване",
      "DISCONNECT": "Disconnect bot",
      "SUCCESS_MESSAGE": "Successfully updated the agent bot.",
      "DISCONNECTED_SUCCESS_MESSAGE": "Successfully disconnected the agent bot.",
      "ERROR_MESSAGE": "Could not update the agent bot. Please try again.",
      "DISCONNECTED_ERROR_MESSAGE": "Could not disconnect the agent bot. Please try again.",
      "SELECT_PLACEHOLDER": "Select bot",
      "COUNTRY_BOTS": {
        "TITLE": "Ботове по държава",
        "DESC": "Тази входяща кутия обслужва няколко държави. Разговорът отива при бота на своята държава: по магазина в Kaufland, по пазара на поръчката в Allegro, а иначе по езика, на който пише клиентът. Всички останали разговори отиват при бота по подразбиране по-горе.",
        "COUNTRY": "Изберете държава",
        "BOT": "Изберете бот",
        "ADD": "Добавяне на бот за държава",
        "REMOVE": "Премахване",
        "DEFAULT_REQUIRED": "Първо изберете бот по подразбиране. Ботът на държава го заменя само за тази държава.",
        "DISCONNECT_ALL": "Изключи всички ботове"
      }
    },
    "ADD": {
      "TITLE": "Configure new bot",
      "CANCEL_BUTTON_TEXT": "Отмени",
      "API": {
        "SUCCESS_MESSAGE": "Bot added successfully.",
        "ERROR_MESSAGE": "Could not add bot. Please try again later."
      }
    },
    "LIST": {
      "404": "No bots found. You can create a bot by clicking the 'Configure new bot' button ↗",
      "LOADING": "Fetching bots...",
      "TABLE_HEADER": {
        "DETAILS": "Подробности за бота",
        "URL": "Webhook URL"
      },
      "TYPE": "Bot type"
    },
    "DELETE": {
      "BUTTON_TEXT": "Изтрий",
      "TITLE": "Delete bot",
      "CONFIRM": {
        "TITLE": "Потвърждение на изтриването",
        "MESSAGE": "Сигурни ли сте, че искате да изтриете {name}?",
        "YES": "Да, изтрий",
        "NO": "Не, запази"
      },
      "API": {
        "SUCCESS_MESSAGE": "Bot deleted successfully.",
        "ERROR_MESSAGE": "Could not delete bot. Please try again."
      },
      "SUBMIT": "Изтрий",
      "CANCEL_BUTTON_TEXT": "Отмени",
      "DESCRIPTION": "Are you sure you want to delete this bot? This action is irreversible."
    },
    "EDIT": {
      "BUTTON_TEXT": "Редактирай",
      "TITLE": "Edit bot",
      "API": {
        "SUCCESS_MESSAGE": "Bot updated successfully.",
        "ERROR_MESSAGE": "Could not update bot. Please try again."
      },
      "LOADING": "Fetching bots...",
      "CANCEL_BUTTON_TEXT": "Отмени"
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Аватар на бота"
      },
      "NAME": {
        "LABEL": "Име на бота",
        "PLACEHOLDER": "Въведете име на бота",
        "REQUIRED": "Името на бота е задължително"
      },
      "DESCRIPTION": {
        "LABEL": "Описание",
        "PLACEHOLDER": "Какво прави този бот?"
      },
      "WEBHOOK_URL": {
        "LABEL": "Webhook URL",
        "PLACEHOLDER": "https://example.com/webhook",
        "REQUIRED": "Webhook URL е задължителен"
      },
      "ERRORS": {
        "NAME": "Името на бота е задължително",
        "URL": "Webhook URL е задължителен",
        "VALID_URL": "Моля, въведете валиден URL, започващ с http:// или https://"
      },
      "CANCEL": "Отказ",
      "CREATE": "Създай бот",
      "UPDATE": "Обнови бот"
    },
    "WEBHOOK": {
      "DESCRIPTION": "Конфигурирайте webhook бот за интеграция с вашите персонализирани услуги. Ботът ще получава и обработва събития от разговори и може да отговаря на тях."
    },
    "TYPES": {
      "WEBHOOK": "Webhook bot",
      "CSML": "CSML bot"
    },
    "CSML_BOT_EDITOR": {
      "NAME": {
        "LABEL": "Bot name",
        "PLACEHOLDER": "Name your bot.",
        "ERROR": "Bot name is required."
      },
      "DESCRIPTION": {
        "LABEL": "Bot description",
        "PLACEHOLDER": "What does this bot do?"
      },
      "BOT_CONFIG": {
        "ERROR": "Please enter your CSML bot configuration above.",
        "API_ERROR": "Your CSML configuration is invalid. Please fix it and try again."
      },
      "SUBMIT": "Validate and save"
    }
  }
}
